import { ModelSagres } from "../../model-sagres";
import { ArquivoLicitacao } from "../arquivo-licitacao";

export class LicitacaoResumida extends ModelSagres {
  IdLicitacao: number;
  NumeroAnoLicitacao: string;
  Modalidade: string;
  Objeto: string;
  ValorEstimado: number;
  ValorLicitado: number;
  DtHomologacao: Date;
  CdSituacao: string;
  Situacao?: string;
  PodeEditar?: boolean;
  PodeCancelar?: boolean;

  ArquivoLicitacao?: ArquivoLicitacao[];
  ArquivoParecer?: any;

  /**
   * Usar o parâmetro opcional para receber um objeto do importador de XML
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.NumeroAnoLicitacao = obj.nrAnoLicitacao;
      this.Modalidade = obj.modalidade;
      this.Objeto = obj.objeto;
      this.ValorEstimado = Number(obj.valorEstimado);
      this.ValorLicitado = Number(obj.valorLicitado);
      this.DtHomologacao = new Date(obj.dtHomologacao);
      this.Situacao = obj.situacao;
      if (obj.PodeEditar) this.PodeEditar = obj.PodeEditar;
      if (obj.PodeCancelar) this.PodeCancelar = obj.PodeCancelar;
    }
  }

  tratarDadosDaAPI(): void {
    if (this.DtHomologacao) {
      this.DtHomologacao = new Date(this.DtHomologacao);
    }
    if (this.CdSituacao) {
      switch (this.CdSituacao) {
        case "EM":
          this.Situacao = "Em Cadastramento";
          break;
        case "LI":
          this.Situacao = "Finalizada";
          break;
        case "AN":
          this.Situacao = "Anulada";
          break;
        case "RE":
          this.Situacao = "Revogada";
          break;
        case "DE":
          this.Situacao = "Deserta";
          break;
        case "FR":
          this.Situacao = "Fracassada";
          break;
        case "JE":
          this.Situacao = "Já Existente";
          break;
        case "NA":
          this.Situacao = "Não Adicionada";
          break;
        default:
          break;
      }
    }
    if (this.ArquivoLicitacao) {
      const arqParecer = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 3)
      if(arqParecer !== undefined) this.ArquivoParecer = Object.assign(new ArquivoLicitacao(), arqParecer);
    }
  }

  isSituacaoCancelada(): boolean {
    return (
      this.Situacao === "Anulada" ||
      this.Situacao === "Revogada" ||
      this.Situacao === "Deserta" ||
      this.Situacao === "Fracassada"
    );
  }

  getTipoArquivo(tipo) {
    if(tipo === 'parecer') {
      if(this.ArquivoParecer instanceof File) return "naosalvo";
      if(this.ArquivoParecer instanceof ArquivoLicitacao) return "salvo";
    }
    return null;
  }
}
